import { Loader } from "lucide-react";
import { useDownsellFlow } from "../../context/use-downsell-flow";

export const DownsellLoading = () => {
  const { downsellData, processingStatus } = useDownsellFlow();

  const isMultipleBookingsCancellation =
    !!downsellData &&
    [
      "booking-and-next-bookings-and-cycles",
      "booking-and-next-bookings",
    ].includes(downsellData.downsell_type);

  const bookingLoadingMessage = isMultipleBookingsCancellation
    ? "Cancelando as reservas..."
    : "Cancelando a reserva...";

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <Loader className="h-12 w-12 animate-spin text-zinc-950" />
      <h2 className="text-xl font-semibold mt-4">
        {processingStatus.currentOperation === "booking"
          ? bookingLoadingMessage
          : "Realizando downsell de pacotes..."}
      </h2>
      <div className="text-center text-zinc-500 text-sm font-normal font-['Inter'] leading-tight mt-4">
        Este processo pode levar alguns instantes. <br />
        Por favor, mantenha esta página aberta e não desligue seu computador.
      </div>
    </div>
  );
};
